import { eachHourOfInterval } from 'date-fns/eachHourOfInterval';
import { endOfDay } from 'date-fns/endOfDay';
import { format } from 'date-fns/format';
import { max } from 'date-fns/max';
import { min } from 'date-fns/min';
import { startOfDay } from 'date-fns/startOfDay';

/**
 * Returns hour options of the provided date.
 */
export function getHoursOfDate(params: GetHoursOfDateParams): HourOption[] {
  const { minDate, maxDate, date } = params;

  const startOfDate = max([startOfDay(date), minDate]);
  const endOfDate = min([endOfDay(date), maxDate]);

  const hourOptionDates = eachHourOfInterval({
    start: startOfDate,
    end: endOfDate,
  });

  return hourOptionDates.map((optionDate) => ({
    value: optionDate.toISOString(),
    label: format(optionDate, 'h:mmaaa'),
  }));
}

// ─── Types ───────────────────────────────────────────────────────────────────

type GetHoursOfDateParams = {
  date: Date;
  minDate: Date;
  maxDate: Date;
};

type HourOption = {
  value: string; // ISO Date String
  label: string;
};
